import { Button, ButtonLink } from './Button';

interface ErrorAction {
  label: string;
  to?: string;
  onClick?: () => void;
}

interface ErrorStateProps {
  /** Qué falló, en términos de lo que la persona quería hacer. */
  title: string;
  /** Qué se sabe de la causa y qué se puede intentar. */
  body: string;
  action?: ErrorAction;
  /** Detalle técnico, sólo visible si se despliega. */
  detail?: string;
}

export function ErrorState({ title, body, action, detail }: ErrorStateProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center gap-3 rounded-card border border-danger/30 bg-danger-soft px-6 py-10 text-center"
    >
      <svg
        viewBox="0 0 24 24"
        className="h-8 w-8 text-danger"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M12 8v5m0 3.5h.01M10.3 3.9 2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h2 className="text-lg font-semibold text-ink">{title}</h2>
      <p className="max-w-sm text-sm text-ink/80">{body}</p>
      {action &&
        (action.to ? (
          <ButtonLink to={action.to} variant="secondary" size="sm">
            {action.label}
          </ButtonLink>
        ) : (
          <Button variant="secondary" size="sm" onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
      {detail && (
        <details className="mt-2 max-w-full text-left">
          <summary className="cursor-pointer text-xs text-muted">Detalle técnico</summary>
          <pre className="mt-2 max-h-40 overflow-auto rounded bg-surface p-3 font-mono text-2xs text-muted">
            {detail}
          </pre>
        </details>
      )}
    </div>
  );
}
